export default __webpack_public_path__ + "static/media/Kale-Closeup-200px.7d650d81.jpg";